import React, { useState } from 'react';
import Layout from '../components/site/Layout';
import useLang from '../i18n/useLang';
import Button, { Arrow } from '../components/site/Button';
import { WhatsAppIcon, whatsappHref } from '../components/site/contact';

// Submissions are collected by the existing Google Form, which is the site's working lead channel.
const FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSf7QgTbbhNX8lPo6tRr1VSdcouy2MKZr42mG2WHBed7241znQ/viewform?embedded=true';
const LINKEDIN = 'https://www.linkedin.com/company/grovv-systems/';

export default function Contact() {
  const { t } = useLang();
  const [loaded, setLoaded] = useState(false);
  const c = (k) => t(`pages.contact.${k}`);

  return (
    <Layout title={t('header.Contact')}>
      <section className="relative isolate overflow-hidden bg-mint-50">
        <div aria-hidden="true" className="absolute -top-32 end-[-8rem] -z-10 h-[30rem] w-[30rem] rounded-full bg-sky-200/60 blur-3xl" />
        <div className="wrap grid grid-cols-1 gap-12 pb-24 pt-16 sm:pt-24 lg:grid-cols-[1fr_1.25fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <h1 className="display max-w-[12ch] text-[2.75rem] text-ink sm:text-6xl lg:text-7xl">{c('title')}</h1>
            <p className="lead mt-6 max-w-[42ch]">{c('lead')}</p>

            <Button
              href={whatsappHref(t('site.whatsapp.message'))}
              target="_blank"
              rel="noopener noreferrer"
              size="lg"
              variant="dark"
              className="mt-8"
            >
              <WhatsAppIcon className="h-5 w-5" />
              {t('site.whatsapp.label')}
            </Button>

            <dl className="mt-12 space-y-6 border-t border-mint-200 pt-8">
              <div>
                <dt className="text-sm font-medium text-ink-500">{c('office')}</dt>
                <dd className="mt-1 text-lg text-ink">{t('site.footer.address')}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-ink-500">{c('linkedin')}</dt>
                <dd className="mt-1">
                  <a href={LINKEDIN} className="group inline-flex items-center gap-1.5 text-lg font-medium text-grovv-800 hover:text-ink">
                    Grovv Systems
                    <Arrow className="h-4 w-4" />
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div className="overflow-hidden rounded-[2rem] bg-white shadow-float ring-1 ring-fog-200">
            <div className="flex items-center justify-between gap-4 border-b border-fog-200 px-6 py-4 sm:px-8">
              <h2 className="text-lg font-semibold text-ink">{c('formTitle')}</h2>
              <span className="text-xs text-ink-500">{c('formNote')}</span>
            </div>
            <div className="relative min-h-[1200px]">
              {!loaded && (
                <div className="absolute inset-0 flex items-start justify-center pt-24 text-ink-500" role="status">
                  {c('loading')}
                </div>
              )}
              <iframe
                src={FORM_URL}
                title={c('formTitle')}
                onLoad={() => setLoaded(true)}
                className="relative block h-[1900px] w-full border-0"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
